import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'antd';
import Tabs from '../../components/Tab';

import Coins from '../../components/Coins';
import { DashLinksToolTip } from '../Hosting/Utils';

const getCoinPairSelect = (currentPresetPair, pairBase, pair2, moveToStep) => {
    if (currentPresetPair.id) {
        return (<div className="coin-container">
            <div className="asset-pairs" onClick={() => moveToStep('pair-selection')}>
                <div>
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <Coins
                                type={pairBase.symbol}
                                small={true}
                            />
                            <span className="coin-full-name">{pairBase.fullname}</span>
                        </div>
                        <Icon type="close" style={{ fontSize: '24px' }} />
                        <div className="d-flex align-items-center">
                            <Coins
                                type={pair2.symbol}
                                small={true}
                            />
                            <span className="coin-full-name">{pair2.fullname}</span>
                        </div>
                    </div>
                </div>
                <Icon type="down" />
            </div>
            {currentPresetPair.issuer
                ? <div className="provider-display">Provider: {currentPresetPair.issuer}</div>
                : null
            }
        </div>)
    } else if (!currentPresetPair.id) {
        return (
            <div className="coin-container">
                <div className="asset-pairs">
                    <div>
                        No markets
                    </div>
                    <Icon type="down" />
                </div>
            </div>
        );
    } else {
        return null;
    }
}

const AddPairTab = ({
    allCoins = [],
    currentPresetPair = {},
    formData = {},
    isExchangeWizard = false,
    onClose,
    moveToStep,
    moveToParentStep,
    activeTab,
    handleTabs,
    handleSelectType,
}) => {
    const pairBase = allCoins.filter((data) => data.symbol === currentPresetPair.pair_base)[0] || {};
    const pair2 = allCoins.filter((data) => data.symbol === currentPresetPair.pair_2)[0] || {};
    const handleNavigate = () => {
        moveToStep('pair-init-selection');
        handleSelectType();
    };

    const renderContent = () => {
        return (
            <div>
                <div className="add-pair-radio-wrapper">
                    {/* <span className="sub-title">Add a preset pair</span> */}
                    {getCoinPairSelect(currentPresetPair, pairBase, pair2, moveToStep)}
                </div>
                <div className="add-pair-radio-wrapper">
                    <div className='d-flex steps-dash-link'>
                        Don't see your market? <span className="anchor" onClick={handleNavigate}>Create a new market</span>
                        <DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=AVAqJMR6ViE&t=218s'}/>
                    </div>
                </div>
            </div>
        )
    };

    const StepList = [
        {
            key: 'hollaexPairs',
            name: 'HollaEx markets',
            description: 'Markets offered by HollaEx',
            content: renderContent()
        },
        {
            key: 'otherPairs',
            name: 'Other markets',
            description: 'Markets offered by other providers',
            content: renderContent()
        },
    ];

    const renderTabBar = ({ activeKey, onTabClick, ...rest }) => {
        return (
            <div className="d-flex ant-tabs-nav">
                {StepList.map((list, index) => (
                    <div
                        key={list.key}
                        className={
                            activeKey === index.toString()
                                ? "ant-tabs-tab ant-tabs-tab-active"
                                : "ant-tabs-tab"
                        }
                        onClick={(e) => onTabClick(index.toString(), e)}
                    >
                        <div>{list.name}</div>
                        <div className="tab-description">{list.description}</div>
                    </div>
                ))}
            </div>
        )
    };

    return (
        <div className="add-pair-wrapper">
            <div className="title">Add Market</div>
            {isExchangeWizard
                ?
                <div className='sub-txt'>
                    Market are based on assets selected in the previous step. To
                        see more markets <Link className='link-color' onClick={() => moveToParentStep(2)}>go back</Link> and add more assets.
                    </div>
                : null
            }
            <Tabs
                TabList={StepList}
                renderTabBar={renderTabBar}
                onChange={handleTabs}
                activeTab={activeTab}
            />
            {/* {!isExchangeWizard */}
            {/* <div className="coin-container">
                <Checkbox
                    name="active"
                    onChange={(e) => handleChange(e.target.checked, 'active')}
                    checked={formData.active}
                >
                    <div className="sub-title">Make Coin Active</div>
                    <div className="description">Activate this trading pair on your exchange immediately after setup.</div>
                </Checkbox>
            </div> */}
            {/* } */}
            <div className="btn-wrapper">
                {/* {!isExchangeWizard ? 
                    <Fragment> */}
                <Button type="primary" onClick={onClose}>
                    Back
                    </Button>
                <div className="separator"></div>
                {/* </Fragment>
                    : null
                } */}
                <Button type="primary" onClick={() => moveToStep('preview')} disabled={!formData.pair_base}>
                    Next
                </Button>
            </div>
        </div>
    );
}

export default AddPairTab;
